module.exports = __webpack_public_path__ + "img/nav-music.deccbd24.png";